import { render } from "./NoticeHelp.vue?vue&type=template&id=6b1770bc&scoped=true"
import script from "./NoticeHelp.vue?vue&type=script&lang=js"
export * from "./NoticeHelp.vue?vue&type=script&lang=js"

import "./NoticeHelp.vue?vue&type=style&index=0&id=6b1770bc&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1770bc"]])

export default __exports__